import React, {useState} from 'react';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {Sidebar} from "../index";
import Drawer from "@mui/material/Drawer";
import GrainIcon from '@mui/icons-material/Grain';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {Link} from "react-router-dom";
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import {Logout} from './../../components'


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
}));

const Header = () => {

    const classes = useStyles();

    const [drawer, setDrawer] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [logout, setLogout] = useState(false);

    return(
        <div className={classes.root}>
            <AppBar position="static" dir={"rtl"}>
                <Toolbar className='display-flex display-flex-direction-row display-flex-justify-content-space-between'>
                    <IconButton  onClick={() => setDrawer(true)} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                        <MenuIcon style={{ color: '#fff'}} />
                    </IconButton>
                    <Link to={'/'}>
                        <Typography style={{ color: '#fff'}} className="display-flex display-flex-justify-content-center">
                            <GrainIcon />&nbsp;
                            <b>دیجی عطار #حکیم عصرجدید</b>
                        </Typography>
                    </Link>
                    <IconButton id='fade-menu' aria-haspopup="true" onClick={(event) => setAnchorEl(event.currentTarget)}>
                        <AccountCircleRoundedIcon style={{ color: '#fff'}} />
                    </IconButton>
                    <Menu
                        id="fade-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                    >
                        <MenuItem onClick={() => {
                            setLogout(true);
                            setAnchorEl(null);
                        }}>
                            <Typography>خروج از سایت</Typography>
                        </MenuItem>
                    </Menu>
                </Toolbar>
                <Drawer anchor="right" open={drawer} onClose={() => setDrawer(false)} style={{left: 'auto'}} dir={"rtl"}>
                    <Sidebar onClose={() => setDrawer(false)}/>
                </Drawer>
                <Logout open={logout} onClose={() => setLogout(false)} />
            </AppBar>
        </div>
    );
}


export default Header;
